export function trackReddit(event: 'SignUp' | 'Custom', params = {}) {
  if (!window.rdt) {
    return;
  }
  window.rdt('track', event, params);
}
